//card component, has header and icon
// a space for 'white' content
//a space for 'gray' content
import React from 'react'

import { CBButton } from './cbd'

const CBIncrementer = ({ defaultValue, onChange, min,max=10000}) => {
return <div className="flex flex-row gap-x-4 items-center justify-center">
  <CBButton 
  disabled={defaultValue==min}
  type="ternary" onClick={e=>{
    if(defaultValue -1 >= min) {
      onChange(defaultValue-1)
    }
  }
}>{'-'}</CBButton><div className="text-lg">{defaultValue}</div><CBButton type="ternary" onClick={e=>{
  if(defaultValue  < max) {
    onChange(defaultValue+1)
  }
    
  }}>{'+'}</CBButton>
</div>

}

export { CBIncrementer }
